import React, { ReactNode } from 'react';
import { Typography, Divider } from 'antd';

const { Text } = Typography;

export interface SettingsGeneralProps {
  /** 是否显示 Electron 特有功能（数据目录、缓存管理等） */
  showElectronFeatures?: boolean;
  /** Electron 特有功能的内容（数据目录、导入导出、缓存管理等） */
  electronFeaturesContent?: ReactNode;
}

/**
 * SettingsGeneral component - unified General settings for Web and Electron
 * - Web: Only shows Cloud Storage (placeholder)
 * - Electron: Shows Cloud Storage + platform-specific features
 */
export const SettingsGeneral: React.FC<SettingsGeneralProps> = ({
  showElectronFeatures = false,
  electronFeaturesContent,
}) => {
  return (
    <div>
      {/* 云端储存 - 两端都显示 */}
      <div style={{ marginBottom: 24 }}>
        <Text strong style={{ fontSize: 16, display: 'block', marginBottom: 12 }}>
          云端储存
        </Text>

        <div
          style={{
            padding: 12,
            background: 'var(--ant-color-bg-container-disabled)',
            borderRadius: 4,
            marginBottom: 8,
          }}
        >
          <div>
            <Text>当前已使用</Text>
            <br />
            <Text type="secondary" style={{ fontSize: 12 }}>
              该功能正在开发中...
            </Text>
          </div>
        </div>

        <Text type="secondary" style={{ fontSize: 12 }}>
          用于存储云端收藏夹
        </Text>
      </div>

      {/* Electron 特有功能 - 只在 showElectronFeatures=true 时显示 */}
      {showElectronFeatures && electronFeaturesContent && (
        <>
          <Divider />
          {electronFeaturesContent}
        </>
      )}
    </div>
  );
};
